<template>
  <div class="list-container">
    <div>
      <div class="filter-container">
        <template v-if="!isFilterCollapse">
          <div class="filter-box">
            <span class="label">采购编号</span>
            <el-input
              v-model="listQuery.no"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">发票号码</span>
            <el-input
              v-model="listQuery.invoiceNo"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <!-- <div class="filter-box">
            <span class="label">发票代码</span>
            <el-input
              v-model="listQuery.invoiceCode"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div> -->
          <div class="filter-box">
            <span class="label">供应商</span>
            <el-input
              v-model="listQuery.supplier"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">开票状态</span>
            <el-select :filterable="true" v-model="listQuery.invoiceStatus" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @change="handleFilter">
              <el-option
                v-for="item in invoiceStatusOptions"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">入库状态</span>
            <el-select :filterable="true" v-model="listQuery.storageStatus" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @change="handleFilter">
              <el-option
                v-for="item in storageStatusOptions"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">材料编号</span>
            <el-input
              v-model="listQuery.materialNo"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">材料品牌</span>
            <el-input
              v-model="listQuery.materialBrand"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">材料名称</span>
            <el-input
              v-model="listQuery.materialName"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">材料型号</span>
            <el-input
              v-model="listQuery.materialModel"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">登记时间</span>
            <el-date-picker
              v-model="listQuery.startTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">到</span>
            <el-date-picker
              v-model="listQuery.endTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">开票时间</span>
            <el-date-picker
              v-model="listQuery.invoiceStartTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">到</span>
            <el-date-picker
              v-model="listQuery.invoiceEndTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">付款时间</span>
            <el-date-picker
              v-model="listQuery.payStartTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">到</span>
            <el-date-picker
              v-model="listQuery.payEndTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <el-radio-group v-model="listQuery.paymentStatus" @change="handleFilter">
              <el-radio label="1,2" >未付款</el-radio>
              <el-radio label="3" >已付款</el-radio>
              <el-radio label="4" >无需付款</el-radio>
              <el-radio label="" >全部</el-radio>
            </el-radio-group>
          </div>
        </template>
        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t("table.search") }}
          </el-button>
          <el-button
            v-permission="{ pkey: `${permissionName}_ADD` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('add')"
          >
            {{ t("table.add") }}
          </el-button>
          <el-button
            v-permission="{ pkey: `${permissionName}_PAYOK` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('batch-payOk')"
          >
            批量财务付款
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t("table.reset") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="isFilterCollapse = !isFilterCollapse"
          >
            {{ isFilterCollapse ? '展开' : '收起' }}
          </el-button>
          <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')">
            <i class="icon-tubiao-27 iconfont"/>
          </span>
          <span class="svg-icon cursor" @click="handleCommand('column')">
            <i class="icon-tubiao-28 iconfont"/>
          </span>
          <span class="ml-10 filter-mark">
            <span class="status-item"><span class="status-square" style="background-color: red;"></span><span class="status-text">待付款、部分付款</span></span>
          </span>
        </div>
      </div>
      <TableList
        ref="tableDataRef"
        v-loading="listLoading"
        :dataList="list"
        :columnAllData="columnAllData"
        :tableName="TableName"
        :permissionName="permissionName"
        :isShowPagination="false"
        :showSelection="true"
        :handleDefaultWidth="180"
        :tableRowClassName="tableRowClassName"
        :showSummary="true"
        @command-change="handleCommand"
      >
        <template v-slot:operation-action="scope">
          <CommandRender
            :scopeRow='scope.row'
            :codeList="btnList"
            :permissionName="permissionName"
            @command-change="handleCommand"
          />
        </template>
      </TableList>
      <el-pagination
        class="mt-20"
        v-show="total > 0"
        :total="total"
        v-model:currentPage="listQuery.page"
        :page-size="listQuery.size"
        :page-sizes="pageSizes"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next"
      />
    </div>
    <el-dialog
      v-model="dialogFormVisible"
      title="财务付款"
      width="70%"
    >
      <div class="form-title mb-10">
        <span class="label blue">采</span>
        <span class="left">采购信息</span>
      </div>
      <MiniBusinessList
        :businessList="selectionRowList"
        ref="miniBusinessList"
        :isRateVisible="false"
        :isShowExpand="false"
      >
        <template v-slot:before>
          <el-table-column prop="no" label="编号" show-overflow-tooltip width="120"/>
          <el-table-column prop="supplier" label="采购商" show-overflow-tooltip width="120">
            <template #default="{ row }">
              {{ row.supplier.name }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="name" label="名称" show-overflow-tooltip width="100"/>
          <el-table-column prop="brand" label="品牌" show-overflow-tooltip/> -->
          <el-table-column prop="total" label="总费用" show-overflow-tooltip align="right" min-width="100">
            <template #default="{ row }">
              {{ $currency(row.total)}}
            </template>
          </el-table-column>
          <el-table-column prop="paid" label=" 已付费用" show-overflow-tooltip align="right" min-width="100">
            <template #default="{ row }">
              {{ $currency(row.paid) }}
            </template>
          </el-table-column>
          <el-table-column prop="paidAmount" label="费用" show-overflow-tooltip align="right" min-width="180">
            <template #default="{ row }">
              <el-input-number v-model="row.paidAmount" type="number" @input='handleFeeInput(row)' :precision="2" :controls-position="right"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="remainAmount" label="待付费用" show-overflow-tooltip align="right" width="100">
            <template #default="{ row }">
              {{ $currency(row.remainAmount)}}
            </template>
          </el-table-column>
        </template>
        <template v-slot:after>
          <el-table-column prop="containsRate" label="是否含税" min-width="100">
            <template #default="{ row }">
              {{ row.containsRate ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column prop="rate" label="税率" min-width="100">
            <template #default="{ row }">
              {{ row.rate || 0}}%
            </template>
          </el-table-column>
          <el-table-column prop="invoiceType" label="发票类型" width="100" show-overflow-tooltip/>
          <!-- <el-table-column prop="status" label="状态" width="100"  show-overflow-tooltip/> -->
          <el-table-column prop="accountAlias" label="账户信息" min-width="180" show-overflow-tooltip >
            <template #default="{ row }">
              {{ row.account?.alias }}
            </template>
          </el-table-column>
        </template>
      </MiniBusinessList>
       <!-- <AccountPreview :account="activeRow.account" v-if="activeRow.account">
        <template v-slot:content>
          <el-descriptions-item label="编号：">{{ activeRow.no }}</el-descriptions-item>
          <el-descriptions-item label="采购商：">{{ activeRow.supplier }}</el-descriptions-item>
          <el-descriptions-item label="总费用：">{{$currency(activeRow.fee)}}</el-descriptions-item>
          <el-descriptions-item label="是否含税：">{{ activeRow.containsRate ? '是' : '否' }}</el-descriptions-item>
          <el-descriptions-item label="税率：">{{ activeRow.rate }}</el-descriptions-item>
          <el-descriptions-item label="发票类型：">{{ activeRow.invoiceType }}</el-descriptions-item>
          <el-descriptions-item label="状态：">{{ activeRow.status }}</el-descriptions-item>
        </template>
      </AccountPreview> -->
      <div class="form-title mt-30 mb-10">
        <span class="label green">支</span>
        <span class="left">支付确认</span>
      </div>
      <el-form
        ref="dataForm"
        :model="formData"
        :rules="rules"
        label-position="top"
        label-width="100px"
        class="mb-20"
      >
        <div class="underlineForm">
          <el-form-item label="付款账户" prop="paymentAccountId" :error="rules.paymentAccountId[0].message">
            <el-select :filterable="true" v-model="formData.paymentAccountId" class="filter-item" placeholder="输入关键字搜索" clearable>
              <el-option
                v-for="item in accountOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="付款时间" prop="paymentTime" :error="rules.paymentTime[0].message">
            <el-date-picker
              v-model="formData.paymentTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="付款备注" prop="paymentMark" class="fullWidth">
            <el-input
              v-model="formData.paymentMark"
              placeholder=" "
              type="textarea"
            />
          </el-form-item>
        </div>
      </el-form>
      <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogFormVisible = false" type="danger">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </span>
      </template>
    </el-dialog>
    <el-dialog
      v-model="paidRecordVisible"
      title="明细"
      width="60%"
      close-on-click-modal
    >
      <ChargeFee :id="activeId" api="purchasFee" />
      <template #footer>
        <span class="dialog-footer">
          <el-button type="danger" @click="paidRecordVisible = false">关闭</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script lang='ts'>

import { defineComponent, reactive, toRefs, onMounted, nextTick, ref, unref } from 'vue'
import { ElMessage, ElForm, ElMessageBox } from 'element-plus'
import { paymentConfirm } from '@/apis/Purchase'
import { getDropdown, putUrl } from '@/apis/Dictionary'
import { getPageList as getUrlList } from '@/apis/Form'
import { CostModel, ArrayRowsItem } from '@/model/Index'
import TableList from '@/components/common/TableList.vue'
import { TableName, permissionName } from '@/utils/enum'
import { TableField } from '@/views/purchasManage/ruku/FieldTable'
import { numberTimes, totalPriceWithoutRate, defaultDate, Today, pageVo, pageSizes } from '@/utils/index'
import { useI18n } from 'vue-i18n'
import mixin from '@/mixins'
// import AccountPreview from '@/views/business/outsourceCompany/AccountPreview/Index.vue'
import MiniBusinessList from '@/views/business/businessList/MiniBusinessList.vue'
import ChargeFee from '@/views/financial/chargeFee/Index.vue'
import CommandRender from '@/components/common/CommandRender.vue'
import { invoiceStatusOptions, paymentStatusOptions, storageStatusOptions } from '@/constant/enumValues'
import { cloneDeep } from 'lodash'
export default defineComponent({
  name: 'Purchasefee',
  components: {
    TableList,
    // AccountPreview,
    MiniBusinessList,
    ChargeFee,
    CommandRender
  },
  setup() {
    const { t } = useI18n()
    const tableDataRef = ref(null)
    const miniBusinessList = ref(null)
    const dataForm = ref(ElForm)
    const dataMap = reactive({
      TableName: TableName.TABLE_FINANCIAL_PURCHASE_FEE,
      permissionName: permissionName.FINANCIAL_PURCHASE_FEE,
      columnAllData: cloneDeep(TableField).filter((k) => !(k.fieldKey in ['virtualStorage'])),

      activeId: 0,
      activeRow: null,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        no: undefined,
        invoiceNo: undefined,
        invoiceCode: undefined,
        supplier: undefined,
        startTime: '',
        endTime: '',
        status: '',
        paymentStatus: '1,2',
        ...pageVo
      },
      pageSizes,
      dialogFormVisible: false,
      paidRecordVisible: false,
      paymentStatusOptions,
      invoiceStatusOptions,
      storageStatusOptions,
      salesManOption: [],
      ReviewStatusOption: [],
      UserPayTypeOption: [],
      submitLoading: false,
      accountOption: [],
      selectionArray: [],
      selectionRowList: [],
      btnList: [],
      formData: {
        paymentAccountId: '',
        paymentTime: '',
        paymentMark: ''
      },
      rules: {
        paymentAccountId: [{ required: true, message: '', trigger: 'change' }],
        paymentTime: [{ required: true, message: '', trigger: 'change' }]
      },
      statusOption: [
        {
          id: 0,
          name: '待付款'
        }, {
          id: 1,
          name: '已付款'
        }
      ],
      handleCommand(command: string, val?: any) {
        switch (command) {
          case 'PAYOK':
          case 'batch-payOk': {
            dataMap.formData = {
              paymentAccountId: '',
              paymentTime: Today,
              paymentMark: ''
            }
            dataMap.activeId = val ? val.id : ''
            dataMap.activeRow = val
            dataMap.selectionRowList = val ? [val] : dataMap.selectionArray
            if (!dataMap.selectionRowList.length) {
              return ElMessage.error({
                message: '请选择数据',
                duration: 1000
              })
            }
            // 采购商
            const firstItem = dataMap.selectionRowList[0]
            const sameFiled = [{ key: 'supplier', name: '采购商', targetField: 'name' }]
            for (let i = 0; i < dataMap.selectionRowList.length; i++) {
              const item = dataMap.selectionRowList[i]
              for (let j = 0; j < sameFiled.length; j++) {
                const kk = sameFiled[j]
                const itemName = kk.targetField ? item[kk.key][kk.targetField] : item[kk.key]
                const firstItemName = kk.targetField ? firstItem[kk.key][kk.targetField] : firstItem[kk.key]
                if (itemName !== firstItemName) {
                  return ElMessage.error({
                    message: `请选择同一个${kk.name}数据`,
                    duration: 1000
                  })
                }
                // if (item[kk.key] !== firstItem[kk.key]) {
                //   return ElMessage.error({
                //     message: `请选择同一个${kk.name}`,
                //     duration: 1000
                //   })
                // }
              }
            }

            // const ids = dataMap.selectionRowList.map((kk: any) => kk.id)
            // getUrlList(`purchase/actions/payments?ids=${ids}`).then((result: any) => {
            dataMap.selectionRowList = dataMap.selectionRowList
              ? dataMap.selectionRowList.map((item: any) => {
                const paid = item.paid || 0
                return {
                  ...item,
                  fee: item.fee,
                  accountAlias: item.account?.alias,
                  paid,
                  paidAmount: item.total - paid,
                  remainAmount: 0
                }
              })
              : []
            // getUrlList(`purchase/batch/details?ids=${ids}`).then((result: any) => {
            //   dataMap.selectionRowList = dataMap.selectionRowList.map((kk: any) => {
            //     const children = result[kk.id]
            //     return {
            //       ...kk,
            //       children
            //     }
            //   })
            // })
            dataMap.dialogFormVisible = true
            // })
            getUrlList('paymentAccount/dropdown').then((res: any) => {
              dataMap.accountOption = res || []
            })
          }
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableDataRef.value as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
          case 'selection':
            dataMap.selectionArray = val
            break
          case 'paid-record':
            dataMap.activeId = val.id
            dataMap.paidRecordVisible = true
            break
          case 'recall':
            dataMap.handleRecall(val)
            break
        }
      },
      getList() {
        const { startTime, endTime } = dataMap.listQuery
        const tempsStart = startTime ? new Date(startTime).getTime() : 0
        const tempdEnd = endTime ? new Date(endTime).getTime() : 0
        if (tempsStart > tempdEnd) {
          return ElMessage.error({
            message: '开始时间必须小于结束时间',
            duration: 1000
          })
        }
        dataMap.listLoading = true
        getUrlList('purchase/page/v2', { ...dataMap.listQuery, pageType: 2 }).then((res: any) => {
          dataMap.list = res.data
            ? res.data.map((k: any) => {
              k.supplierAccount = k.supplierAccount || {}
              return {
                ...k,
                supplierAccountName: k.supplierAccount.name,
                supplierAccountType: k.supplierAccount.type,
                supplierAccountBranchName: k.supplierAccount.branchName,
                supplierAccount: k.supplierAccount.account,
                feeWithoutRate: 0,
                totalPrice: dataMap.totalPriceWithoutRate(k.fee, k.amount, true, k.rate),
                totalPriceWithRate: dataMap.numberTimes(k.fee, k.amount, true)
              }
            })
            : []
          dataMap.total = res.total
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      numberTimes: (price: any, amount: any, isCurrency: boolean) => numberTimes(price, amount, isCurrency),
      totalPriceWithoutRate: (price: any, amount: any, isCurrency: boolean, rate: any) => totalPriceWithoutRate(price, amount, isCurrency, rate),
      handleReset() {
        dataMap.listQuery = {
          no: undefined,
          invoiceNo: undefined,
          invoiceCode: undefined,
          supplier: undefined,
          startTime: defaultDate[0],
          endTime: defaultDate[1],
          status: '',
          paymentStatus: '1,2',
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        dataMap.getList()
      },

      handlePayOk(row: any) {
        dataMap.activeId = row.id
        dataMap.activeRow = row
        dataMap.dialogFormVisible = true
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      loadDropdownList(url: string) {
        getDropdown(url).then((res: any) => {
          dataMap[`${url}Option`] = res
        })
      },
      handleCancle() {
        dataMap.dialogFormVisible = true
      },
      async handleSubmit() {
        const form = unref(dataForm)
        form.validate(async(valid: any) => {
          if (valid) {
            try {
              const businessList = (miniBusinessList.value as any).businessList
              const params = {
                accountId: dataMap.formData.paymentAccountId,
                date: dataMap.formData.paymentTime,
                paymentMark: dataMap.formData.paymentMark,
                payments: businessList.map((kk: any) => {
                  return {
                    id: kk.id,
                    amount: kk.paidAmount
                  }
                })
              }
              await paymentConfirm(params)
              dataMap.dialogFormVisible = false
              dataMap.getList()
              ElMessage({
                message: '提交成功',
                type: 'success',
                duration: 1000
              })
            } catch (err: any) {
              if (err && err.errors) {
                err.errors.forEach((item: any) => {
                  const field = dataMap.rules[item.field][0]
                  if (field) {
                    field.message = null
                    nextTick(() => {
                      field.message = item.defaultMessage
                    })
                  }
                })
              }
            }
          }
        })
      },
      handleFeeInput(item: any) {
        item.remainAmount = item.fee - item.paid - Number(item.paidAmount)
        item.paidAmount = Number(item.paidAmount)
      },
      tableRowClassName({ row }: any) {
        // 待财务付款-红色
        const obj = {
          待付款: 'row-red',
          部分付款: 'row-red'
        }
        return obj[row.paymentStatusValue]
      },
      handleRecall(row: any) {
        ElMessageBox.confirm(
          '确定同意撤回选中数据吗？',
          '提示',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            putUrl(`purchase/${row.id}/actions/apply/returned`).then(() => {
              dataMap.getList()
              ElMessage({
                message: '操作成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      }
    })
    const { mixinData } = mixin(dataMap)
    onMounted(async() => {
      dataMap.listQuery.startTime = defaultDate[0]
      dataMap.listQuery.endTime = defaultDate[1]
      dataMap.listQuery.paymentStatus = '1,2'
      dataMap.btnList = [
        {
          pkey: `${dataMap.permissionName}_PAYOK`,
          name: '财务付款',
          command: 'PAYOK'
        },
        {
          pkey: `${dataMap.permissionName}_PAYOK`,
          name: '同意撤回',
          command: 'recall',
          visible: (row: any) => {
            return ['申请撤回'].includes(row.status)
          }
        },
        {
          pkey: `${dataMap.permissionName}_PAID_RECORD`,
          name: '付款明细',
          command: 'paid-record'
        }
      ]
      dataMap.getList()
    })
    return { t, ...toRefs(dataMap), ...toRefs(mixinData), tableDataRef, miniBusinessList, dataForm }
  }
})
</script>
<style lang="scss" scope>
.statusStyle {
  .status {
    // border: 1px solid;
    padding: 0 4px;
    border-radius: 6px;
    margin-right: 7px;
    font-size: 10px;
    color: #fff;
  }
}

.redStatusStyle {
  .icon-tubiao-40 {
    color: #E74228;
  }

  .status {
    background-color: #E74228;
  }
}

.yellowStatusStyle {
  .icon-tubiao-40 {
    color: #F3D03C;
  }

  .status {
    background-color: #F3D03C;
  }
}
</style>
